import { Component, Inject } from "@angular/core";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { AuditLogEntry } from "../audit-log.interface";

@Component({
  selector: "app-audit-log-details-dialog",
  templateUrl: "./audit-log-details-dialog.component.html",
  styleUrls: ["./audit-log-details-dialog.component.scss"],
  standalone: false,
})
export class AuditLogDetailsDialogComponent {
  readonly formattedLog: string;
  readonly formattedBefore: string | null;
  readonly formattedAfter: string | null;
  readonly formattedMetadata: string | null;

  constructor(
    public dialogRef: MatDialogRef<AuditLogDetailsDialogComponent>,
    @Inject(MAT_DIALOG_DATA) public data: AuditLogEntry,
  ) {
    this.formattedLog = this.formatValue(data);
    this.formattedBefore = this.formatOptional(data.before);
    this.formattedAfter = this.formatOptional(data.after);
    this.formattedMetadata = this.formatOptional(data.metadata);
  }

  close(): void {
    this.dialogRef.close();
  }

  private formatOptional(value: unknown): string | null {
    if (value === null || value === undefined) {
      return null;
    }
    return this.formatValue(value);
  }

  private formatValue(value: unknown): string {
    return JSON.stringify(value, null, 2);
  }
}
